import { useState, useEffect } from 'react';
import {
  useExperiments,
  useHttpClient,
} from '@wix/fe-essentials-standalone/react';
import { listAppTemplates } from '@wix/ambassador-devcenter-apps-v1-app-template/http';
import {
  type AppTemplate,
  DevelopmentTool,
} from '@wix/ambassador-devcenter-apps-v1-app-template/types';

export const useCliTemplatesQuery = () => {
  const [templates, setTemplates] = useState<AppTemplate[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const httpClient = useHttpClient();
  const { experiments } = useExperiments({ readOnly: true });
  const showAllTemplates = experiments.enabled(
    'specs.dcc.appBuilderCLITemplates',
  );

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setIsLoading(true);
        // Use the same API call as app-templates-page
        const {
          data: { appTemplates },
        } = await httpClient.request(listAppTemplates({}));

        // Filter only CLI templates
        const cliTemplates = (appTemplates || [])
          .filter((template) => {
            return (
              template.developmentTools?.includes(DevelopmentTool.CLI) &&
              template.id &&
              (showAllTemplates || !EXCLUDED_TEMPLATES.includes(template.id))
            );
          })
          .slice(0, showAllTemplates ? 20 : 5);

        cliTemplates.unshift({
          id: 'start-from-scratch-template',
          title: 'Blank Canvas',
          subtitle: 'Start from scratch and explore the new workspace.',
          thumbnail: '',
          developmentTools: [DevelopmentTool.CLI],
        });
        setTemplates(cliTemplates);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch CLI templates:', err);
        setError(
          err instanceof Error ? err : new Error('Failed to fetch templates'),
        );
        // Fallback to empty array on error
        setTemplates([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplates();
  }, [httpClient, showAllTemplates]);

  return { templates, isLoading, error };
};

// 2ff7a5ae-d116-4c06-9394-7d7493428d0e

const EXCLUDED_TEMPLATES = [
  '2ff7a5ae-d116-4c06-9394-7d7493428d0e',
  'a033018e-233a-4ddc-8471-1151d8974866',
  '5fcf03b8-46ba-499b-8dbb-40ecf811aceb',
];
